<template>
  <div class="system-container">
    <div class="container-box1">
      <div class="box1-text1">PROGRAMME</div>
      <div class="box1-text2">智慧灌溉系统解决方案</div>
      <div class="box1-blueline"></div>
      <div class="box1-text3">运用基于扩频通信的超远距离、低功耗的LORA无线传输技术，对农业中的环境温度、湿度、光照强度等不同界面情况进行实时监控，分析处理传感器数据信息。达到所设阈值或人为干涉操作，作为灌溉设备运行的控制条件，实现智能化灌溉。</div>
      <div class="box1-img"></div>
    </div>
    <div class="container-box2">
      <div class="box2-text1">VALUE</div>
      <div class="box2-text2">方案价值</div>
      <div class="box1-blueline"></div>
      <div class="box2-text3">改变了以往关于传输距离和功率相矛盾的问题。</div>
    </div>
    <div class="crumbs-nav">
      <svg t="1647833705034" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3680" width="0.2rem" height="0.2rem"><path d="M938.412716 480.847489 556.823881 104.126522c-1.89721-2.258437-6.142907-6.194072-12.037151-10.081613-9.920954-6.544043-21.162995-10.520611-33.496905-10.520611-13.180184 0-24.690332 3.997034-34.357506 10.623965-5.846148 4.010337-9.876951 8.102538-12.157901 11.154038L84.209914 480.894561c-14.700817 14.481829-14.700817 38.014802 0 52.529377 14.585183 14.427594 33.995255 8.343015 50.529837-7.945973l25.607214-25.314549 38.918381-37.700647c-1.359974 1.686409-2.282996 2.963495-2.284019 3.373841L196.981327 847.484797c0 50.006927 40.941458 90.427522 91.442642 90.427522l141.713582 0 10.423397 0L440.560948 927.486876 440.560948 686.440961c0-17.467837 14.411221-31.683607 32.223912-31.683607l77.051887 0c17.814738 0 32.223912 14.21577 32.223912 31.683607L582.060659 927.486876l0 10.425444 10.425444 0 141.713582 0c50.485835 0 91.442642-40.428781 91.442642-90.427522L825.642327 467.251843l62.246693 61.207014c20.142759 13.266142 37.897122 17.434068 50.523697 4.963035C953.114556 518.910387 953.114556 495.361041 938.412716 480.847489z" p-id="3681" fill="#c6c6c6"></path></svg>
      <div class="crumbs-text1"  @click="goToHome">首页</div>
      <div class="crumbs-text2">产品服务</div>
      <div class="crumbs-text3" @click="goToAgriculture">消防培训</div>
      <div class="crumbs-text4">智慧灌溉系统解决方案</div>
      <img src="../../../../assets/images/路径 93.png" alt="" class="crumbs-img1" @click="goToHome">
      <img src="../../../../assets/images/路径 94.png" alt="" class="crumbs-img2">
      <img src="../../../../assets/images/路径 95(1).png" alt="" class="crumbs-img3" @click="goToAgriculture">
      <img src="../../../../assets/images/路径 96.png" alt="" class="crumbs-img4">
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/componets/footer/Footer"
export default {
  components: {
    Footer
  },
  methods: {
    goToHome() {
      this.$router.push("/home")
    },
    goToAgriculture() {
      this.$router.back()
    }
  },
}
</script>

<style lang="less" scoped>
.system-container {
  width: 19.2rem;
  font-size: 0.22rem;
  position: relative;
  font-family: Source Han Sans CN;
}
.container-box1 {
  width: 19.2rem;
  height: 10.05rem;
  margin-top: 0.3rem;
  overflow:hidden;
  background-color: #FAFAFB;
  }
.box1-text1 {
  width: 1.37rem;
  height: 0.27rem;
  font-family: DIN;
  font-weight: 400;
  margin-left: 8.92rem;
  margin-top: 0.58rem;
  line-height: 0.27rem;
  color: #ADADAD;
}
.box1-text2 {
  width: 3.8rem;
  height: 0.56rem;
  font-size: 0.38rem;
  font-weight: 400;
  line-height: 0.56rem;
  margin-top: 0.1rem;
  margin-left: 7.7rem;
  color: #333333;
}
.box1-blueline {
  width: 0.5rem;
  height: 0.04rem;
  background-color: #0078FF;
  margin-top: 0.2rem;
  margin-left: 9.35rem;
}
.box1-text3 {
  width: 12rem;
  height: 0.86rem;
  text-align: left;
  font-weight: 400;
  line-height: 0.5rem;
  margin-top: 0.5rem;
  margin-left: 3.6rem;
  color: #666666;
}
.box1-img {
  width: 12rem;
  height: 6.04rem;
  background-image: url("../../../../assets/images/zhgg.png");
  background-size: 12rem 6.04rem;
  background-repeat: no-repeat;
  margin-top: 0.5rem;
  margin-left: 3.6rem;
}
.box2-text1 {
  width: 0.67rem;
  height: 0.27rem;
  font-family: DIN;
  font-weight: 400;
  line-height: 0.27rem;
  margin-top: 0.5rem;
  margin-left: 9.27rem;
  color: #ADADAD;
}
.box2-text2 {
  width: 1.52rem;
  height: 0.56rem;
  font-size: 0.38rem;
  font-weight: 400;
  line-height: 0.56rem;
  margin-top: 0.1rem;
  margin-left: 8.84rem;
  color: #333333;
}
.box2-text3 {
  width: 12rem;
  height: 0.37rem;
  font-weight: 400;
  line-height: 0.5rem;
  margin-top: 0.5rem;
  margin-left: 3.6rem;
  margin-bottom: 1.1rem;
  color: #666666;
}
//蓝色的面包屑导航
.crumbs-nav {
  width: 8rem;
  height: 0.6rem;
  font-size: 0.16rem;
  position: relative;
  position: absolute;
  top: -0.6rem;
  left: 2.6rem;
}
.crumbs-nav img {
  cursor: pointer;
}
.icon {
  position: absolute;
  top: 0.18rem;
  left: 0.41rem;
  z-index: 99;
}
.crumbs-text1 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 0.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text2 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 1.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text3 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 3.14rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text4 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 4.4rem;
  color: #FFFFFF;
  z-index: 99;
}
.crumbs-img1 {
  width: 1.45rem;
  height: 0.6rem;
  position: absolute;
  left: 0;
  z-index: 3;
}
.crumbs-img2 {
  width: 2.04rem;
  height: 0.6rem;
  position: absolute;
  left: 0.72rem;
  z-index: 2;
}
.crumbs-img3 {
  width: 2.07rem;
  height: 0.6rem;
  position: absolute;
  left: 2.17rem;
  z-index: 1
}
.crumbs-img4 {
  width: 2.62rem;
  height: 0.6rem;
  position: absolute;
  left: 3.7rem;
}
</style>
